import { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { MdAccountCircle } from "react-icons/md";
import { FaSignOutAlt } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { API, Auth } from "aws-amplify";
import useAuthState from "../hooks/useAuthState";
import StoresIcon from "../images/store.svg";
import ProductsIcon from "../images/products.svg";
import AvatarIcon from "../images/avatar.png";
import { Feature } from "flagged";
import { useTranslation } from "react-i18next";
import { LanguageSelection } from "./LanguageSelection";
import { clearStorage } from "../helpers/storage";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexFlow: "column",
    width: "95px",
    minWidth: "95px",
    height: "100%",
    zIndex: 1,
    boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.75)",

    "& #avatarIcon": {
      width: "40px",
      marginLeft: "-10px",
    },
    "& a": {
      textDecoration: "none",
    },
    "& #sidebarHeader": {
      paddingTop: "20px",
      paddingBottom: "30px",
    },
    "& #sidebarContent": {
      flex: "1 1 auto",
      display: "flex",
      flexDirection: "column",
    },
    "& .scrollArea": {
      flex: "1 1 auto",
      overflowY: "auto",
      paddingBottom: "60px",
    },
    "& .bottomDiv": {
      position: "absolute",
      bottom: "0",
      left: "0",
      right: "0",
      background: "white",
      zIndex: "1",
    },
    "& .languageOptions": {
      marginTop: "auto", // 👈 this pushes it to the bottom
      padding: "10px 0", // optional spacing
    },
    "& .sidebar-links": {
      padding: "10px 16px 10px 6px",
      marginBottom: "1px",
      fontSize: "20px",
      fontWeight: 700,
    },
    "& .sidebar-links.active": {
      paddingLeft: "1px",
      borderLeft: "5px solid white",
    },
    "& .link-img": {
      width: "28px",
    },
  },
}));

function Sidebar() {
  const classes = useStyles();
  const history = useHistory();
  const { setAuthStatus, User } = useAuthState();
  const [activeLink, setActiveLink] = useState("");
  const [UserGroup, setUserGroup] = useState("");
  const [EmailAddresses, setEmailAddresses] = useState([]);
  const [UserConfigData, setUserConfigData]: [any, any] = useState([]);
  const { t } = useTranslation();
  useEffect(() => {
    ExportAllEmailAddresses();
  }, []);

  function ExportAllEmailAddresses() {
    API.get("AE", `/Customers/GetCustomers`, { response: true })
      .then((res) => {
        res.data.forEach((part) => {
          part.ModifiedAt = part.ModifiedAt.substring(0, 10);
        });
        setEmailAddresses(res.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  }

  const signOut = () => {
    Auth.signOut()
      .then((data) => {
        clearStorage();
        setAuthStatus("noUser");
        history.push("/login");
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    const value = localStorage.getItem("UserConfigData");
    if (typeof value === "string") {
      setUserConfigData(JSON.parse(value));
    }
  }, []);
  useEffect(() => {
    if (User.attributes["custom:role"]) {
      setUserGroup(User.attributes["custom:role"]);
    }
  }, [User]);

  let featureMultilingual = false;
  if (UserConfigData && UserConfigData.EnabledFeatures) {
    if (UserConfigData.EnabledFeatures.includes("multilingual")) {
      featureMultilingual = true;
    }
  }

  return (
    <div id="sidebar" className={classes.root}>
      <div id="sidebarHeader">
        <div className="flex-center-justify" id="avatar">
          <img id="avatarIcon" src={AvatarIcon} alt="Avatar" />
        </div>
      </div>
      <div id="sidebarContent">
        <Link
          title={t("sidebar.retaillocations")}
          to="/retail-locations"
          id="retailLocations"
          onClick={() => setActiveLink("/retail-locations")}
        >
          <div
            className={`sidebar-links ${
              activeLink === "/retail-locations" ? "active" : ""
            }`}
          >
            <div className="flex-center-justify">
              <img
                className="link-img"
                src={StoresIcon}
                alt="/retail-locations"
              />
            </div>
          </div>
        </Link>

        {UserGroup !== "replenishmentuser" ? (
          <Link
            title={t("sidebar.productmanagement")}
            to="/product-management"
            id="productManagement"
            onClick={() => setActiveLink("/product-management")}
          >
            <div
              className={`sidebar-links ${
                activeLink === "/product-management" ? "active" : ""
              }`}
            >
              <div className="flex-center-justify">
                <img
                  className="link-img"
                  src={ProductsIcon}
                  alt="/product-management"
                />
              </div>
            </div>
          </Link>
        ) : null}

        {UserGroup !== "replenishmentuser" ? (
          <Link
            title={t("sidebar.usermanagement")}
            to="/user-management"
            id="userManagement"
            onClick={() => setActiveLink("/user-management")}
          >
            <div
              className={`sidebar-links ${
                activeLink === "/user-management" ? "active" : ""
              }`}
            >
              <div className="flex-center-justify">
                <MdAccountCircle size={24} />
              </div>
            </div>
          </Link>
        ) : null}

        <Feature name="barcodescanpromotionemail">
          <div className={`sidebar-links`}>
            <div className="flex-center-justify"></div>
          </div>
        </Feature>

        <Link title={t("sidebar.logout")} onClick={() => signOut()} to="/">
          <div className={`sidebar-links`}>
            <div className="flex-center-justify">
              <FaSignOutAlt size={24} />
            </div>
          </div>
        </Link>
        { featureMultilingual && 
        <div className="languageOptions">
          <LanguageSelection />
        </div> }
      </div>
    </div>
  );
}

export default Sidebar;
